export const DATE = 'Fri 17 Apr 12:52:45 CEST 2026';
